import i18n from "PFCore/i18n";

const fmtDate = (date) => `${date.toLocaleString(i18n.language, { month: "long" })} ${date.getFullYear()}`;

const getPeriod = (startDate, endDate, current) => {
  const end = !current && endDate ? new Date(endDate) : null;
  const startText = startDate ? fmtDate(new Date(startDate)) : null;
  const endText = end ? fmtDate(end) : "Present";
  return startDate ? `${startText} - ${endText}` : "";
};

export default getPeriod;
